import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/color.css';
import './index.css';
import App from './App';
import { installGlobalErrorReporter } from './api/errorReporter';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
installGlobalErrorReporter();
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
